import styled from "styled-components";

export const TemplateHeader = styled.div`
    width: 100%;
    padding: 20px 50px 15px 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    border-bottom: 1px solid rgba(236, 236, 236, 1);
    background-color: var(--white);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    .title-wrap {
        display: flex;
        gap: 30px;
        .header-title {
            font-size: 24px;
            line-height: 28px;
            font-weight: 400;
            margin-bottom: 4px;
        }
        .template-name {
            color: rgba(119, 119, 119, 1);
            font-size: 14px;
            line-height: 18px;
            font-weight: 400;
        }
    }
    .btn-wrap {
        display: flex;
        gap: 15px;
    }
`;

export const StyledEditTemplate = styled.div`
    width: 100%;
    padding: 100px 50px 20px 370px;
    display: flex;
    justify-content: space-between;
    gap: 12px;
    .preview-section {
        width: 100%;
        .preview-img {
            width: 100%;
        }
    }
`;
